export const getCurrentLocation = () => window.location.href;

export const reloadLocation = (url?: string) => {
    window.location.href = url ?? getCurrentLocation();
};

export const getCurrentPathName = () => window.location.pathname;

export const addURLParameter = (key: string, value: string, url?: string) => {
    url ??= getCurrentLocation();

    let symbolParameter = "?";
    if (url.indexOf("?") !== -1) {
        symbolParameter = "&";
    }

    let kvPair = key + "=" + encodeURIComponent(value);
    return url.replace(/(#|$)/, symbolParameter + kvPair + "$1");
};

/**
 * Reads current location and returns decoded value for specified parameter.
 * Returns null if there is no such parameter in url.
 */
export const getURLParameter = (name: string): string => {
    const url = new URL(getCurrentLocation());
    return url.searchParams.get(name);
};

export const getEncodedURLParameter = (name: string, url?: string): string => {
    url ??= getCurrentLocation();
    let results = new RegExp("[\\?&#]" + name + "=([^&#]*)", "i").exec(url);

    return results ? results[1] : null;
};

/** @deprecated please use {@link getURLParameter}, which works with the browser's native method. */
export const getDecodedURLParameter = (name: string, url?: string) => {
    let value = getEncodedURLParameter(name, url);

    return value ? decodeURIComponent(value) : null;
};

export const getReturnUrl = (returnUrl: string): string => {
    const returnUrlValue = returnUrl || ep.appRoot;
    const currentUrl = new URL(document.baseURI);
    const redirectUrl = new URL(returnUrlValue, document.baseURI);

    // check the host will not change after redirect
    if (currentUrl.origin === redirectUrl.origin) {
        return returnUrlValue;
    }

    // otherwise prevent redirect to external url
    return ep.appRoot;
};

export const trimEndSlash = (str: string) => str.replace(/\/$/, "");
